import React, { memo, useCallback, useEffect, useState } from 'react';
import { useEvent, useMapContext } from '../../hooks';
import { button, container } from './styles';
import TrafficIcon from './TrafficIcon';
var TrafficControl = function (_a) {
    var _b = _a.defaultActiveColor, defaultActiveColor = _b === void 0 ? '#fc0' : _b;
    var map = useMapContext();
    var provider = useState(function () {
        return new ymaps.traffic.provider.Actual({}, { infoLayerShown: true });
    })[0];
    var _c = useState(false), active = _c[0], setActive = _c[1];
    var _d = useState('none'), iconStyle = _d[0], setIconStyle = _d[1];
    var clickHandler = useCallback(function () {
        provider.setMap(active ? null : map);
        setActive(!active);
    }, [active, provider, map]);
    var changeHandler = useCallback(function () {
        var nextIconStyle = provider.state.get('iconStyle');
        if (nextIconStyle !== iconStyle) {
            setIconStyle(nextIconStyle);
        }
    }, [provider, iconStyle]);
    useEffect(function () {
        map.layers.options.set({
            trafficInfoOpenBalloonOnClick: false
        });
        return function () {
            map.layers.options.set({
                trafficInfoOpenBalloonOnClick: true
            });
        };
    }, [map]);
    useEffect(function () { return function () {
        provider.setMap(null);
    }; }, [provider]);
    // fixme нет нормальных типов для Provider
    useEvent(provider.state, 'change', changeHandler);
    return (React.createElement("div", { style: container },
        React.createElement("button", { type: "button", style: button, onClick: clickHandler },
            React.createElement(TrafficIcon, { fill: active ? iconStyle || defaultActiveColor : 'none' }))));
};
export default memo(TrafficControl);
